import { render, staticRenderFns } from "./SummaryTable.vue?vue&type=template&id=36c390fa"
import script from "./SummaryTable.vue?vue&type=script&lang=js"
export * from "./SummaryTable.vue?vue&type=script&lang=js"
import style0 from "./SummaryTable.vue?vue&type=style&index=0&id=36c390fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports